
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/press/release/[slug]",
      function () {
        return require("private-next-pages/[locale]/press/release/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/press/release/[slug]"])
      });
    }
  